import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class GoalCollectionsOrganizations extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'GoalCollectionsOrganizations'
  // Define default properties here
  static instanceDefaults () {
    return {
      goalCollectionId: null,
      organizationId: null,
    }
  }
}
const servicePath = 'goal-collections-organizations'
const servicePlugin = makeServicePlugin({
  Model: GoalCollectionsOrganizations,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
